import Component from '../core/Component'
import { limit } from '../utils/Number'

export default class FocusPoint extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            image: null
        }

        this.options = {
            focusX: 0,
            focusY: 0
        }

        this.isLoaded = false
    }

    prepare() {
        window.addEventListener('resize', this.handleResize)

        const image = new Image()
        image.onload = ::this.handleLoad
        image.src = this.element.src

        this.adjust()
    }

    destroy() {
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize = () => {
        this.adjust()
    }

    handleLoad() {
        this.isLoaded = true
        this.adjust()
    }

    adjust() {
        if (!this.isLoaded) {
            return
        }

        const parent = this.element.parentNode
        const parentBox = parent.getBoundingClientRect()
        const box = this.element.getBoundingClientRect()

        const center = {
            x: box.width/2,
            y: box.height/2
        }

        const vector = {
            x: center.x * this.options.focusX,
            y: center.y * this.options.focusY
        }

        const limitOffset = {
            x: Math.abs(parentBox.width - box.width)/2,
            y: Math.abs(parentBox.height - box.height)/2
        }

        const offset = {
            x: (center.x + limit(vector.x, -limitOffset.x, limitOffset.x))/box.width,
            y: (center.y - limit(vector.y, -limitOffset.y, limitOffset.y))/box.height
        }

        // limit
        this.element.style.transform = `translate(${-offset.x * 100}%,${-offset.y * 100}%)`

    }
}